export const BETA_EXPERIMENT_ENABLE_KEY = 'willShowNav4';

export type Nav4CheckProp = {
  isNav4Admin: boolean;
  isSiteEnrolledToNav4: boolean;
  townsquareApp: 'home' | 'goals' | 'teams'; // TODO: This needs to use a global apps type
};
